export enum Mode {
  New = "new",
  Edit = "edit",
}
